import styled from 'styled-components/macro';
import theme from 'styled-theming';

import useIsPhoneDevice from '@hooks/useIsPhoneDevice';
import {colors, dark, fonts, light, textSizes} from '@styles/vars';

import {useEffect} from 'react';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2100000;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: auto;
  background:
    radial-gradient(circle at 15% 20%, rgba(58, 124, 165, 0.22), transparent 36%),
    radial-gradient(circle at 85% 80%, rgba(39, 174, 96, 0.16), transparent 34%),
    ${theme('theme', {
        light: light.bodyBg,
        dark: dark.bodyBg,
    })};
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  border-radius: 16px;
  padding: 28px 24px;
  text-align: center;
  border: 1px solid ${theme('theme', {
      light: light.border,
      dark: dark.border,
  })};
  background: ${theme('theme', {
      light: light.widgetBg,
      dark: dark.widgetBg,
  })};
  box-shadow: ${theme('theme', {
      light: '0 18px 40px rgba(7, 18, 30, 0.12)',
      dark: '0 18px 40px rgba(0, 0, 0, 0.35)',
  })};
  display: grid;
  gap: 16px;
`;

const IconWrap = styled.div`
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
  color: ${colors.blue};
  background: rgba(38, 98, 240, 0.12);
`;

const Title = styled.h1`
  margin: 0;
  font-family: ${fonts.accent};
  font-size: ${textSizes[20]};
  font-weight: 600;
  color: ${theme('theme', {
      light: light.text,
      dark: dark.text,
  })};
`;

const Message = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${textSizes[14]};
  line-height: 1.55;
  color: ${theme('theme', {
      light: colors.gray,
      dark: dark.text,
  })};
  opacity: 0.92;
`;

const Hint = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${textSizes[12]};
  line-height: 1.45;
  color: ${theme('theme', {
      light: colors.secondary,
      dark: dark.text,
  })};
  opacity: 0.85;
`;

const MobileUnsupportedNotice = () => {
    const isPhone = useIsPhoneDevice();

    useEffect(() => {
        const html = document.documentElement;
        if (isPhone) {
            html.classList.add('no-scroll');
        } else {
            html.classList.remove('no-scroll');
        }
        return () => html.classList.remove('no-scroll');
    }, [isPhone]);

    if (!isPhone) {
        return null;
    }

    return (
        <Overlay role="alertdialog" aria-modal="true" aria-labelledby="mobile-unsupported-title">
            <Card>
                <IconWrap aria-hidden="true">
                    <i className="icon icon-phone" />
                </IconWrap>
                <Title id="mobile-unsupported-title">Dispositivo no compatible</Title>
                <Message>
                    MediWorks no está diseñado para teléfonos móviles. Por favor, accede desde una
                    tableta o un equipo de escritorio para una mejor experiencia.
                </Message>
                <Hint>Tabletas y computadoras son los dispositivos recomendados.</Hint>
            </Card>
        </Overlay>
    );
};

export default MobileUnsupportedNotice;
